<template>
  <div class="io-record">
    <!-- <div class="left content-left">
      <AreaTree v-on:handleTreeClick="handleTreeClick" :moduleName="moduleName"></AreaTree>
    </div> -->
    <div>
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for>道路:</label>
            <search-parking></search-parking>
          </div>
          <div class="form-group">
            <label for>岗位:</label>
            <search-area></search-area>
          </div>
          <div class="form-group">
            <label for="bdate">进场时间:</label>
            <el-date-picker
              clearable
              v-model="search.beginDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for="bdate">出场时间:</label>
            <el-date-picker
              clearable
              v-model="search.chargeDate"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
            ></el-date-picker>
          </div>
          <div class="form-group">
            <label for>泊位:</label>
            <input
              v-model="search.spaceNum"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :disabled="loading"
              >
                查询
              </button>
            </span>
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :disabled="loading"
            >
              导出
            </button>
          </div>
        </form>
      </div>
      <!--左侧列表展示进出场记录-->
      <div v-loading:loading="loading"  element-loading-text="数据加载中..."
           >
        <div class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData.rows"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
          >
            <el-table-column
              show-overflow-tooltip
              label="停车道路"
              prop="parkingName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="岗位"
              prop="areaName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="泊位编号"
              prop="spaceNum"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="车牌"
              prop="carNumber"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="进场时间"
              prop="beginDate"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="出场时间"
              prop="endDate"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="地磁出场时间"
              prop="attr2"
            ></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="150px">
              <template slot-scope="scope">
                <button
                  class="delete"
                  @click="del(scope.row.lmId)"
                  type="button"
                >
                  删除
                </button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <Page v-on:pagination="receivePaginationData"></Page>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import {
  delIORecord,
  getAllIOList,
  getIORecordList,
  dictValue,
  getAppList,
  getHandsetSingle,
  dealHandset,
} from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

import SearchParking from "@/page/commons/searchParking";

import SearchArea from "../../commons/searchArea";

import dayjs from "dayjs";

export default {
  data() {
    return {
      treeData: {
        parkingId: "",
      },
      observer: null,
      recordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        elementHeight: "0",
      },
      observer1: null,
      innerRecordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        innerHeight: "0",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      moduleName: "",
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        spaceNum: null,
        beginDate: [dayjs().subtract(1, "month"), dayjs()],
        chargeDate: null,
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},
      loading: false, // 添加loading状态

      defaultProps: {
        children: "children",
        label: "label",
      },
      downloadFileds: {
        停车道路: "parkingName",
        泊位段: 'attr7==undefind&&attr7==""?"":JSON.parse(attr7).areaName',
        泊位编号: "spaceNum",
        车牌: "carNumber",
        进场时间: "beginDate",
        出场时间: "endDate",
      },
      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },

    tableList: function (curPage) {
      var _this = this;
      this.loading = true; // 开始请求时显示loading
      this.$get(getIORecordList(), {
        inBeginTime: this.search.beginDate
          ? JSON.stringify(
              this.search.beginDate.map((date) => this.formatDate(date))
            )
          : null,
        outBeginTime: this.search.chargeDate
          ? JSON.stringify(
              this.search.chargeDate.map((date) => this.formatDate(date))
            )
          : null,
        limit: this.search.pageSize,
        page: curPage,
        parkingId: this.parking?.parkingId ?? null,
        areaId: this.area?.areaId ?? null,
        spaceNum: this.search.spaceNum ? this.search.spaceNum : null,
      })
        .then((data) => {
          if (data.status != 200) return;
          var rows = data.data.rows;
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.getPage(pageObj);
          _this.tableListData.rows = data.data.rows;
          _this.$nextTick(() => {
            _this.$refs.table.doLayout();
          });
        })
        .finally(() => {
          this.loading = false; // 请求结束后隐藏loading
        });
    },
    checkSearchDate() {
      //判断进出场时间是否存在
      if (!(this.search.beginDate || this.search.chargeDate)) {
        this.$message({
          type: "warning",
          message: "进出场时间必选其一,且在一个月内",
        });
        return false;
      }

      //如果进场时间存在，是否在一个月内
      if (this.search?.beginDate && !this.search?.chargeDate) {
        const [date1, date2] = this.search?.beginDate;

        if (dayjs(date2).diff(dayjs(date1), "day") > 31) {
          this.$message({
            type: "warning",
            message: "时间在一个月内",
          });
          return false;
        }
      }
      //如果出场时间存在，是否在一个月内
      if (this.search?.chargeDate && !this.search?.beginDate) {
        const [date1, date2] = this.search?.chargeDate;
        if (dayjs(date2).diff(dayjs(date1), "day") > 31) {
          this.$message({
            type: "warning",
            message: "时间在一个月内",
          });
          return false;
        }
      }
      //如果进出场时间都存在
      if (this.search?.chargeDate && this.search?.beginDate) {
        const [chargeDate1, chargeDate2] = this.search?.chargeDate;
        const [beginDate1, beginDate2] = this.search?.beginDate;
        if (
          dayjs(chargeDate2).diff(dayjs(chargeDate1), "day") > 30 &&
          dayjs(beginDate2).diff(dayjs(beginDate1), "day") > 30
        ) {
          this.$message({
            type: "warning",
            message: "进出场时间必有其一在一个月内",
          });
          return false;
        }
      }
      return true;
    },
    searchList: function () {
      this.search.pageNumber = 1;

      if (!this.checkSearchDate()) return;

      this.tableList(this.search.pageNumber);
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM-DD");
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
    },
    downloadData() {
      if (!this.checkSearchDate()) return;
      this.$downloadFileRequest(
        "/api/parking/lotMsg/lotMsgExport",
        {
          inBeginTime: !this.search.beginDate
            ? null
            : JSON.stringify(
                this.search.beginDate.map((date) => this.formatDate(date))
              ),
          outBeginTime: !this.search.chargeDate
            ? null
            : JSON.stringify(
                this.search.chargeDate.map((date) => this.formatDate(date))
              ),
          parkingId: this.parking?.parkingId ?? null,
          areaId: this.area?.areaId ?? null,
          spaceNum: this.search.spaceNum ? this.search.spaceNum : null,
        },
        "进出记录"
      );
    },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该记录吗？",
        {
          btn: ["确定", "取消"],
          shade: false,
          type: 0,
        },
        function () {
          _this.$layer.close(index);
          // console.log("222")
          _this.loading = true; // 删除时显示loading
          _this
            .$deleteRequest(`${delIORecord()}/${id}`)
            .then((data) => {
              if (data.status != 200)
                return _this.$layer.msg("删除失败", { time: 1 });
              _this.$notify({
                type: "success",
                title: "成功",
                message: "删除成功",
              });
              _this.tableList(_this.curIndex);
            })
            .finally(() => {
              _this.loading = false; // 删除请求结束后隐藏loading
            });
        }
      );
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      parking: (state) => state.parking.oneParking,
      area: (state) => state.parking.area,
    }),
  },
  components: {
    Page,
    AreaTree,
    SearchParking,
    SearchArea,
    // Refresh
  },

  mounted: function () {
    this.tableList(this.search.pageNumber);
  },
};
</script>

<style scoped>
.boxbgcolor {
  width: 100%;
  display: flex;
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
/* .left{
		width:20%;
		float:left;
		/*border-right:1px solid #278cd8;*/
/*margin-right:0.5%*/
/* }
	.right{
		width:80%;
		float:right;
		position:relative;
		height:660px;
	}  */
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
		line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
</style>
<style>
.io-record .el-date-editor.el-input,
.io-record .el-date-editor.el-input__inner {
  width: inherit;
  max-width: inherit;
}
</style>
